export const getRandomColor = (flag?: number) => {
    if (flag) {
        //flag===false 为rgb表示形式：rgb()
        let x1 = Math.floor(Math.random() * 256);
        let x2 = Math.floor(Math.random() * 256);
        let x3 = Math.floor(Math.random() * 256);
        return `rgb(${x1},${x2},${x3})`;
        // return rgb(x1, x2, x3)
    }
    //true/无参数为十六进制
    else {
        let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
        let str = '#'; //使用str数组将颜色字符拼接起来
        for (let i = 0; i < 6; i++) {
            let random = Math.floor(Math.random() * arr.length);
            str += arr[random]; //通过随机下标获取数组元素
        }
        return str;
    }
};
